import { render, staticRenderFns } from "./UnitMeasureSettings.vue?vue&type=template&id=1c1bffbc"
import script from "./UnitMeasureSettings.vue?vue&type=script&lang=js"
export * from "./UnitMeasureSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports